import React from 'react'
import SvgBase from 'utils/ui/SvgBase'

const Love = props => (
  <SvgBase {...props} viewBox="-1 -1 26 26">
    <path id="body" fill="#8fb0d4" stroke="#fff" strokeWidth="2" strokeLinecap="round" d="M11.9282386,3.88634783 C12.8968979,1.59882609 15.1097419,0.00047826087 17.6835532,0.00047826087 C21.1506622,0.00047826087 23.6476719,2.95565217 23.9615982,6.47756522 C23.9615982,6.47756522 24.1310416,7.35182609 23.7580741,8.92578261 C23.250224,11.0693478 22.0564403,12.9737826 20.4469682,14.4272174 L11.9282386,22 L3.5530318,14.4267391 C1.94355975,12.9737826 0.749775975,11.0688696 0.241925862,8.92530435 C-0.131041564,7.35134783 0.0384018097,6.47708696 0.0384018097,6.47708696 C0.352328061,2.95517391 2.84933778,0 6.31644682,0 C8.89073809,0 10.9595793,1.59882609 11.9282386,3.88634783 Z" />
  </SvgBase>
)

export default Love
